import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterProductsLatamComponent} from './register-products-latam.component';

const routes: Routes = [
  {path: '', component: RegisterProductsLatamComponent},
  {path: ':id', component: RegisterProductsLatamComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterProductsLatamRoutingModule { }
